import { render, staticRenderFns } from "./vessel_reg.vue?vue&type=template&id=fe0b7254&scoped=true&"
import script from "./vessel_reg.vue?vue&type=script&lang=js&"
export * from "./vessel_reg.vue?vue&type=script&lang=js&"
import style0 from "./vessel_reg.vue?vue&type=style&index=0&id=fe0b7254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0b7254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fe0b7254', component.options)
    } else {
      api.reload('fe0b7254', component.options)
    }
    module.hot.accept("./vessel_reg.vue?vue&type=template&id=fe0b7254&scoped=true&", function () {
      api.rerender('fe0b7254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/admin/vessel/vessel_reg.vue"
export default component.exports